import { css as r } from "@microsoft/fast-element";
import { normalize as t } from "../common/normalize.js";
import { display as a } from "@matrix42/fast-foundation";
import { typography as i } from "../styles/typography.js";
import { designTokens as e } from "../design-tokens.js";
const p = r`
  ${t}
  ${a("flex")}
  .control {
    /* Typography */
    ${i("p", "regular")}

    align-items: center;
    display: flex;
  }

  .feedback {
    gap: ${e.spacing[2]};
    align-items: center;
    display: flex;
  }

  .feedback > label {
    ${i("label", "regular")}
    color:${e.color.neutral[80]};
  }

  .satisfaction-rating {
    display: flex;
    align-items: center;
  }

  .feedback-button {
    width: 32px;
    display: flex;
    padding: 0.375rem ${e.spacing[2]};
    border-radius: 0.625rem;
    justify-content: center;
    align-items: center;
    gap: ${e.spacing[2]};
  }

  .feedback-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
`;
export {
  p as feedbackStyles
};
